import { useContext, useEffect, useSyncExternalStore } from 'react';
import { FirebaseContext } from '@/session/FirebaseContext';
import type { Country } from '@/models/country';
import {
  ensureCountryPickRatesSubscription,
  getCountryPickRatesSnapshot,
  subscribeCountryPickRatesStore,
} from '@/models/countryPickRates';

/** Live pick-rate percentages keyed by country (public read). */
export function useCountryPickRates(): Partial<Record<Country, number>> | undefined {
  const ctx = useContext(FirebaseContext);

  useEffect(() => {
    ensureCountryPickRatesSubscription(ctx.db);
  }, [ctx.db]);

  return useSyncExternalStore(
    subscribeCountryPickRatesStore,
    getCountryPickRatesSnapshot,
    getCountryPickRatesSnapshot,
  );
}
